module.exports = __webpack_public_path__ + "static/media/W18-1011_AW_Free_RootBeer_desktop_hero_2396x1473_fr_v2.572ca83c.jpg";